import * as React from "react";
import { cn } from "@/lib/utils";

const TableContainer = React.forwardRef<
    HTMLDivElement,
    React.HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => (
    <div
        ref={ref}
        className={cn(
            // overflow-x-auto lets wide tables scroll horizontally on narrow
            // (mobile) viewports instead of being clipped or squeezed.
            "overflow-x-auto rounded-lg border border-table-border bg-table-surface",
            className,
        )}
        {...props}
    />
));
TableContainer.displayName = "TableContainer";

export { TableContainer };
